<!--
 * @Author: 范向玲
 * @Date: 2022-12-06 15:39:08
 * @LastEditTime: 2024-06-03 14:00:36
 * @LastEditors: chenmengnan chenmengnan@piesat.cn
 * @Description: 走势库数据管理--详情表格
 * @FilePath: \web\src\components\ReportComponents\DataManager\edit.vue
-->
<template>
  <section class="trend-edit-container">
    <a-form class="trend-edit-container" :model="formData" name="basic" ref="formRef" :rules="rules"
      :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
      <a-form-item label="报告名称" name="name">
        <a-input v-model:value="formData.name" />
      </a-form-item>
      <a-form-item label="作者/机构" name="owner">
        <a-input v-model:value="formData.owner" />
      </a-form-item>
      <a-form-item label="国家" name="country" v-if="type === '国别报告'">
        <a-select v-model:value="formData.country" :options="countryList" />
      </a-form-item>
      <a-form-item label="矿种" name="minerals" v-if="type === '矿种报告'">
        <a-select v-model:value="formData.minerals" :options="mineList" />
      </a-form-item>
      <a-form-item label="报告日期" name="reportDate">
        <a-month-picker v-model:value="formData.reportDate" :valueFormat="'YYYY-MM'" />
      </a-form-item>
      <a-form-item label="积分值" name="integral">
        <a-input v-model:value="formData.integral" />
      </a-form-item>
      <a-form-item label="文件上传" name="file">
        <FileUpload @fileList="importFileList" :fileListProps="fileListProps" /> <span
          style="color:#B7A480">仅支持pdf格式文件</span>

      </a-form-item>
      <!-- <a-form-item label="是否展示" name="shows">
        <a-radio-group v-model:value="formData.shows">
          <a-radio :value='0'>不展示</a-radio>
          <a-radio :value='1'>展示</a-radio>
        </a-radio-group>
      </a-form-item> -->
    </a-form>
  </section>
</template>

<script setup>

import { ref, watch, defineProps, defineExpose, } from 'vue';
import FileUpload from '@/components/lib/Upload/fileUploadMarket.vue';


const props = defineProps({
  formState: {
    type: Object,
  },
  type: {
    type: String,
  },
  countryList: {
    type: Array,
  },
  mineList: {
    type: Array,
  },
});
const fileListProps = ref([]);


// let formData = JSON.parse(JSON.stringify(props.formState));
let formData = props.formState;

fileListProps.value = [{
  name: formData.fileName,
  uid: formData.reportFile && formData.reportFile.id,
  status: 'done',
}];
/**
 * 点击导入报告
 */

const importFileList = (data) => {
  formData.fileList = data.fileList;
  formData.fileId = data.id;
};


const validateFile = (rule, value, callback) => {
  if (value) {
    if (formData.fileId) {
      callback();
    } else {
      callback(new Error('请上传文件！'));
    }
  } else {
    callback();
  }
};

const rules = {
  name: [{ required: true, message: '请输入报告名称!', trigger: 'blur', },],
  owner: [{ required: true, message: '请输入作者/机构!', trigger: 'blur', },],
  reportDate: [{ required: true, message: '请选择报告时间!', trigger: 'change', },],
  integral: [{ required: true, message: '请输入积分!', },],
  country: [{ required: true, message: '请输入国家!', trigger: 'blur', },],
  minerals: [{ required: true, message: '请输入!', trigger: 'blur', },],
  file: [{ required: true, message: '请输入!', trigger: 'change', type: 'object', validator: validateFile },],
};


const formRef = ref();

defineExpose({ formRef, formData });

</script>

<style lang="scss">
.trend-edit-container {

  .ant-radio-wrapper {
    color: #fff;
  }

  .ant-form-item-label>label {
    color: #fff;
  }

  .ant-select {
    .ant-select-selector {
      padding: 0.1rem;
      background-color: transparent;
      border-color: #695933;
      font-size: 0.16rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      line-height: .43rem;
      height: .43rem;
      display: flex;
      align-items: center;
    }
  }

  .ant-calendar-picker {
    width: 100%;
  }
}
</style>
